export default __webpack_public_path__ + "static/media/ibx-logo.55508f92.svg";